import { TranslationFunction } from 'src/common/hooks/widgets/useTranslation';

export const dataArray = (type: string, translation: TranslationFunction) => {
  if (type === 'assessment')
    return {
      sections: [
        {
          section: translation('section1', true),
          question: translation('section1_ques', true),
          answers: [
            {
              answer: translation('section1_ans1', true),
              weightage: translation('number_1', true),
              desc: translation('section1_ans1_desc', true),
            },
            {
              answer: translation('section1_ans2', true),
              weightage: translation('number_2', true),
              desc: translation('section1_ans2_desc', true),
            },
            {
              answer: translation('section1_ans3', true),
              weightage: translation('number_3', true),
              desc: translation('section1_ans3_desc', true),
            },
            {
              answer: translation('section1_ans4', true),
              weightage: translation('number_4', true),
              desc: translation('section1_ans4_desc', true),
            },
            {
              answer: translation('section1_ans5', true),
              weightage: translation('number_5', true),
              desc: translation('section1_ans5_desc', true),
            },
          ],
          subsection: [
            {
              featureDesc: translation('section1_subsec1_feature_desc', true),
              questionName: translation('section1_subsec1_quesName', true),
              questions: [
                {
                  question: translation('section1_subsec1_ques1', true),
                  from: translation('option_not_all', true),
                  to: translation('option_throughly', true),
                  answers: [
                    {
                      weightage: translation('number_1', true),
                    },
                    {
                      weightage: translation('number_2', true),
                    },
                    {
                      weightage: translation('number_3', true),
                    },
                    {
                      weightage: translation('number_4', true),
                    },
                    {
                      weightage: translation('number_5', true),
                    },
                  ],
                },
                {
                  question: translation('section1_subsec1_ques2', true),
                  from: translation('option_not_all', true),
                  to: translation('option_throughly', true),
                  answers: [
                    {
                      weightage: translation('number_1', true),
                    },
                    {
                      weightage: translation('number_2', true),
                    },
                    {
                      weightage: translation('number_3', true),
                    },
                    {
                      weightage: translation('number_4', true),
                    },
                    {
                      weightage: translation('number_5', true),
                    },
                  ],
                },
              ],
            },
            {
              featureName: translation('section1_subsec2_quesName', true),
              featureDesc: translation('section1_subsec2_feature_desc', true),
              questionName: translation('section1_subsec2_quesName', true),
              questions: [
                {
                  question: translation('section1_subsec2_ques1', true),
                  from: translation('option_not_all', true),
                  to: translation('option_throughly', true),
                  answers: [
                    {
                      weightage: translation('number_1', true),
                    },
                    {
                      weightage: translation('number_2', true),
                    },
                    {
                      weightage: translation('number_3', true),
                    },
                    {
                      weightage: translation('number_4', true),
                    },
                    {
                      weightage: translation('number_5', true),
                    },
                  ],
                },
                {
                  question: translation('section1_subsec2_ques2', true),
                  from: translation('option_not_all', true),
                  to: translation('option_very', true),
                  answers: [
                    {
                      weightage: translation('number_1', true),
                    },
                    {
                      weightage: translation('number_2', true),
                    },
                    {
                      weightage: translation('number_3', true),
                    },
                    {
                      weightage: translation('number_4', true),
                    },
                    {
                      weightage: translation('number_5', true),
                    },
                  ],
                },
                {
                  question: translation('section1_subsec2_ques3', true),
                  from: translation('option_not_all', true),
                  to: translation('option_throughly', true),
                  answers: [
                    {
                      weightage: translation('number_1', true),
                    },
                    {
                      weightage: translation('number_2', true),
                    },
                    {
                      weightage: translation('number_3', true),
                    },
                    {
                      weightage: translation('number_4', true),
                    },
                    {
                      weightage: translation('number_5', true),
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          section: translation('section2', true),
          question: translation('section2_ques', true),
          answers: [
            {
              answer: translation('section2_ans1', true),
              weightage: translation('number_1', true),
              desc: translation('section2_ans1_desc', true),
            },
            {
              answer: translation('section2_ans2', true),
              weightage: translation('number_2', true),
              desc: translation('section2_ans2_desc', true),
            },
            {
              answer: translation('section2_ans3', true),
              weightage: translation('number_3', true),
              desc: translation('section2_ans3_desc', true),
            },
            {
              answer: translation('section2_ans4', true),
              weightage: translation('number_4', true),
              desc: translation('section2_ans4_desc', true),
            },
            {
              answer: translation('section2_ans5', true),
              weightage: translation('number_5', true),
              desc: translation('section2_ans5_desc', true),
            },
          ],
          subsection: [
            {
              featureDesc: translation('section2_subsec1_feature_desc', true),
              questionName: translation('section2_subsec1_quesName', true),
              questions: [
                {
                  question: translation('section2_subsec1_ques1', true),
                  from: translation('option_never', true),
                  to: translation('option_regularly', true),
                  answers: [
                    {
                      weightage: translation('number_1', true),
                    },
                    {
                      weightage: translation('number_2', true),
                    },
                    {
                      weightage: translation('number_3', true),
                    },
                    {
                      weightage: translation('number_4', true),
                    },
                    {
                      weightage: translation('number_5', true),
                    },
                  ],
                },
                {
                  question: translation('section2_subsec1_ques2', true),
                  from: translation('option_not_all', true),
                  to: translation('option_throughly', true),
                  answers: [
                    {
                      weightage: translation('number_1', true),
                    },
                    {
                      weightage: translation('number_2', true),
                    },
                    {
                      weightage: translation('number_3', true),
                    },
                    {
                      weightage: translation('number_4', true),
                    },
                    {
                      weightage: translation('number_5', true),
                    },
                  ],
                },
                {
                  question: translation('section2_subsec1_ques3', true),
                  from: translation('option_not_all', true),
                  to: translation('option_throughly', true),
                  answers: [
                    {
                      weightage: translation('number_1', true),
                    },
                    {
                      weightage: translation('number_2', true),
                    },
                    {
                      weightage: translation('number_3', true),
                    },
                    {
                      weightage: translation('number_4', true),
                    },
                    {
                      weightage: translation('number_5', true),
                    },
                  ],
                },
              ],
            },
            {
              featureDesc: translation('section2_subsec2_feature_desc', true),
              questionName: translation('section2_subsec2_quesName', true),
              questions: [
                {
                  question: translation('section2_subsec2_ques1', true),
                  from: translation('option_never', true),
                  to: translation('option_continuously', true),
                  answers: [
                    {
                      weightage: translation('number_1', true),
                    },
                    {
                      weightage: translation('number_2', true),
                    },
                    {
                      weightage: translation('number_3', true),
                    },
                    {
                      weightage: translation('number_4', true),
                    },
                    {
                      weightage: translation('number_5', true),
                    },
                  ],
                },
                {
                  question: translation('section2_subsec2_ques2', true),
                  from: translation('option_never', true),
                  to: translation('option_continuously', true),
                  answers: [
                    {
                      weightage: translation('number_1', true),
                    },
                    {
                      weightage: translation('number_2', true),
                    },
                    {
                      weightage: translation('number_3', true),
                    },
                    {
                      weightage: translation('number_4', true),
                    },
                    {
                      weightage: translation('number_5', true),
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          section: translation('section3', true),
          question: translation('section3_ques', true),
          answers: [
            {
              answer: translation('section3_ans1', true),
              weightage: translation('number_1', true),
              desc: translation('section3_ans1_desc', true),
            },
            {
              answer: translation('section3_ans2', true),
              weightage: translation('number_2', true),
              desc: translation('section3_ans2_desc', true),
            },
            {
              answer: translation('section3_ans3', true),
              weightage: translation('number_3', true),
              desc: translation('section3_ans3_desc', true),
            },
            {
              answer: translation('section3_ans4', true),
              weightage: translation('number_4', true),
              desc: translation('section3_ans4_desc', true),
            },
            {
              answer: translation('section3_ans5', true),
              weightage: translation('number_5', true),
              desc: translation('section3_ans5_desc', true),
            },
          ],
          subsection: [
            {
              featureDesc: translation('section3_subsec1_feature_desc', true),
              questionName: translation('section3_subsec1_quesName', true),
              questions: [
                {
                  question: translation('section3_subsec1_ques1', true),
                  from: translation('option_not_all', true),
                  to: translation('option_throughly', true),
                  answers: [
                    {
                      weightage: translation('number_1', true),
                    },
                    {
                      weightage: translation('number_2', true),
                    },
                    {
                      weightage: translation('number_3', true),
                    },
                    {
                      weightage: translation('number_4', true),
                    },
                    {
                      weightage: translation('number_5', true),
                    },
                  ],
                },
                {
                  question: translation('section3_subsec1_ques2', true),
                  from: translation('option_not_all', true),
                  to: translation('option_throughly', true),
                  answers: [
                    {
                      weightage: translation('number_1', true),
                    },
                    {
                      weightage: translation('number_2', true),
                    },
                    {
                      weightage: translation('number_3', true),
                    },
                    {
                      weightage: translation('number_4', true),
                    },
                    {
                      weightage: translation('number_5', true),
                    },
                  ],
                },
                {
                  question: translation('section3_subsec1_ques3', true),
                  from: translation('option_not_all', true),
                  to: translation('option_quickly', true),
                  answers: [
                    {
                      weightage: translation('number_1', true),
                    },
                    {
                      weightage: translation('number_2', true),
                    },
                    {
                      weightage: translation('number_3', true),
                    },
                    {
                      weightage: translation('number_4', true),
                    },
                    {
                      weightage: translation('number_5', true),
                    },
                  ],
                },
                {
                  question: translation('section3_subsec1_ques4', true),
                  from: translation('option_not_all', true),
                  to: translation('option_throughly', true),
                  answers: [
                    {
                      weightage: translation('number_1', true),
                    },
                    {
                      weightage: translation('number_2', true),
                    },
                    {
                      weightage: translation('number_3', true),
                    },
                    {
                      weightage: translation('number_4', true),
                    },
                    {
                      weightage: translation('number_5', true),
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          section: translation('section4', true),
          question: translation('section4_ques', true),
          answers: [
            {
              answer: translation('section4_ans1', true),
              weightage: translation('number_1', true),
              desc: translation('section4_ans1_desc', true),
            },
            {
              answer: translation('section4_ans2', true),
              weightage: translation('number_2', true),
              desc: translation('section4_ans2_desc', true),
            },
            {
              answer: translation('section4_ans3', true),
              weightage: translation('number_3', true),
              desc: translation('section4_ans3_desc', true),
            },
            {
              answer: translation('section4_ans4', true),
              weightage: translation('number_4', true),
              desc: translation('section4_ans4_desc', true),
            },
            {
              answer: translation('section4_ans5', true),
              weightage: translation('number_5', true),
              desc: translation('section4_ans5_desc', true),
            },
          ],
          subsection: [
            {
              questionName: translation('section4_subsec1_quesName', true),
              questions: [],
              featureDesc: translation('section4_subsec1_feature_desc', true),
            },
          ],
        },
      ],
      text_right: translation('text_right', true),
      chartValues: [
        translation('section1_subsec1_quesName', true),
        translation('section1_subsec2_quesName', true),
        translation('section2_subsec1_quesName', true),
        translation('section2_subsec2_quesName', true),
        translation('section3_subsec1_quesName', true),
      ],
    };
  else if (type === 'pdfData')
    return {
      page1: {
        heading: translation('pdf_page1_heading', true),
        client: translation('pdf_page1_client', true),
        business: translation('pdf_page1_business', true),
        image: '',
        logo: '',
      },
      page2: {
        heading: translation('pdf_page2_heading', true),
        desc: translation('pdf_page2_desc', true),
        link: 'https://ibm.biz/CyberAssess',
      },
      page3: {
        heading: translation('pdf_page3_heading', true),
        sections: [
          {
            heading: translation('pdf_page3_section1_h', true),
            scoreLabel: translation('pdf_page_score', true),
            color: '#4ab2df',
            desc: translation('pdf_page3_section1_desc', true),
          },
          {
            heading: translation('pdf_page3_section2_h', true),
            scoreLabel: translation('pdf_page_score', true),
            color: '#4ab2df',
            desc: translation('pdf_page3_section2_desc', true),
          },
          {
            heading: translation('pdf_page4_section1_h', true),
            scoreLabel: translation('pdf_page_score', true),
            color: '#fab647',
            desc: translation('pdf_page4_section1_desc', true),
          },
          {
            heading: translation('pdf_page4_section2_h', true),
            scoreLabel: translation('pdf_page_score', true),
            color: '#fab647',
            desc: translation('pdf_page4_section2_desc', true),
          },
          {
            heading: translation('pdf_page4_section3_h', true),
            scoreLabel: translation('pdf_page_score', true),
            color: '#7ef59f',
            desc: translation('pdf_page4_section3_desc', true),
          },
        ],
      },
      page5: {
        heading: translation('pdf_page5_heading', true),
        color: '#76B2C2',
        scoreLabel: translation('pdf_page_score', true),
        scoreKeyLabel: translation('pdf_page5_scoreKey', true),
        scoreLimit: [
          {
            label: translation('pdf_page5_score1_label', true),
            desc: translation('pdf_page5_score1_desc', true),
          },
          {
            label: translation('pdf_page5_score2_label', true),
            desc: translation('pdf_page5_score2_desc', true),
          },
          {
            label: translation('pdf_page5_score3_label', true),
            desc: translation('pdf_page5_score3_desc', true),
          },
          {
            label: translation('pdf_page5_score4_label', true),
            desc: translation('pdf_page5_score4_desc', true),
          },
          {
            label: translation('pdf_page5_score5_label', true),
            desc: translation('pdf_page5_score5_desc', true),
          },
        ],
        footnote: translation('pdf_page5_footnote', true),
        footNoteLink: 'https://ibm.biz/CyberAssess',
        footNoteBtnLabel: translation('pdf_page5_footnoteBtn', true),
      },
    };
};
